"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useLabel = function useLabel(initialLabel, initialProps, canFloat) {
  if (canFloat === void 0) {
    canFloat = true;
  }

  if (!initialLabel && !(initialProps != null && initialProps.labelAria)) return {};
  var value = initialProps.value,
      id = initialProps.id,
      name = initialProps.name,
      floatLabel = initialProps.floatLabel,
      required = initialProps.required,
      labelAria = initialProps.labelAria;

  var labelRequired = function labelRequired(label, req) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !label ? labelAria : label, req && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("sup", null, "*"), /*#__PURE__*/_react.default.createElement("div", {
      className: "show-for-sr",
      id: (name || id) + "-required-message"
    }, "This field is required")));
  };

  var label = /*#__PURE__*/_react.default.createElement('label', {
    id: "label-" + (name || id),
    htmlFor: name || id,
    className: (0, _clsx.default)(floatLabel && 'float-label', value && value.length > 0 && floatLabel && 'filled', value && Object.keys(value).length > 0 && floatLabel && 'filled', labelAria && 'show-for-sr')
  }, labelRequired(initialLabel, required));

  return canFloat ? {
    label: label
  } : {
    label: labelRequired(initialLabel, required)
  };
};

var _default = useLabel;
exports.default = _default;